import { put, call, all, takeEvery, delay, select } from "redux-saga/effects";
import bulkUploadActions from "./action";
import axios from "axios";
import { API_URL } from "../../utils/constants";
import commonActions from "../common/actions";
import Cookies from 'js-cookie';
import setAuthToken from "../../utils/setAuthToken";

const bulkUploadSagas = function* () {
    yield all([
        yield takeEvery(bulkUploadActions.UPLOAD_BULK_CANDIDATE_DATA, bulkUploadData),
     
    ])
};

const bulkUploadData = function* (data) {
    const { payload } = data;
    // const { navigate } = payload;
    yield put({ type: commonActions.SET_BUTTON_LOADER, payload: true });
    yield put({ type: commonActions.SET_PAGE_LOADER, payload: true });
    try {
        let formData = new FormData()
        formData.append("bulkuploadfile", payload?.data)
        const result = yield call(() =>
            axios.post(`${API_URL}/backoffice/bulkuploadcandidate/${payload?.courseid}`, formData)
        );
        // yield delay(10000)
        yield put({ type: commonActions.SET_PAGE_LOADER, payload: false });

        yield put({ type: commonActions.SET_BUTTON_LOADER, payload: false });
        yield put({
            type: commonActions.SET_ALERT,
            payload: {
                status: (result?.data?.statusCode === 200) ? 'success' : 'failed',
                show: true,
                message: result?.data?.jobid != -1 ? result?.data?.message :
                "Another Candidate Upload in Progress"
            }
        });
        if (result?.data?.statusCode === 200 && result?.data?.bulkuploadid) {
            //  payload?.setStatusModalOpen({
            //   open: false,
            //   statustext: "",
            // });
            payload?.setStatusModalOpen({
              open: true,
              statustext: "Processing...",
              isloader:true
            });
            let intervalId = payload.getDataInterval(
              result?.data?.bulkuploadid
            );
            payload.setIntervalId(intervalId);
          } else {
            payload?.setStatusModalOpen({
              open: false,
              statustext: "",
            });
          }
      
        // yield delay(2000);
        yield put({
            type: commonActions.SET_ALERT,
            payload: { status: null, show: false, message: null }
        });
    } catch (err) {
         ;
        Cookies.remove('mhet_mst_token');
        Cookies.remove('mhet_mst_userid');
        window.location.href = `/${Cookies.get('mhet_mst_project')}/userlogin`;
    };
};


export default bulkUploadSagas;